import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import {Router} from '@angular/router'
import { ApiService } from '../../app/api.service';
import { StoreService } from '../../app/store.service';
import {CommonService} from '../../app/common.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
	selector: 'component-menu-bar',
	templateUrl: './component.html',
	styleUrls: ['./component.css',]
})
export class ComponentMenuBar implements OnInit, OnDestroy {
  @Input() assetsRoute: string;
  @Input() exerciseBook: any;
  @Input() userAuthority: any;
  @Input() isHaveTools: boolean;
  @Input() showMentorRedDot: boolean = false;
  @Output() logout = new EventEmitter<any>();
  @Output() showGDPR = new EventEmitter<any>();
  @Output() mentorEntered = new EventEmitter<void>();
  @Output() menuBarClose = new EventEmitter<void>();
	avatarUrl:string;
	userName:string;
	accountName:string;
	showScreenClassName:string = '';
	dialogOpacity:number = 0;
	dialogDisplay:string = 'none';
	multiValidUserAccount:boolean = false
	isChannel:boolean = false;
	assetsRouteUrl: string;
	isShowCover: boolean = false;
	userCamp: any;
  mentorEnteredLocal = false;
  mentorRedDotSub: Subscription;

  get showToastFlag():boolean{
    if (!this.exerciseBook || !this.exerciseBook.length) {
      return true;
    }
    return this.exerciseBook.every(item=>{
      return item.toastFlag === 0;
    })
  }

  get showHamburgerRedDot(): boolean {
    return !this.showToastFlag || this.showMentorRedDot;
  }

  get hasLeaderCoach(): boolean {
    return this.commonService.hasLeaderCoachAuthority(this.userAuthority);
  }

  get showTools(): boolean {
    return this.isHaveTools || this.commonService.hasToolsAuthority(this.userAuthority);
  }

  get showMentorNewBadge(): boolean {
    return this.hasLeaderCoach && !this.mentorEnteredLocal;
  }

	constructor(private router: Router,private store:StoreService, private commonService: CommonService,private apiService:ApiService,private storeService:StoreService) {

	}

	showOrCloseFullPage(){
		const wasOpen = this.showScreenClassName === 'open';
		const newClassName = this.showScreenClassName == 'open' ? '':'open';
    this.showScreenClassName = newClassName;
    this.isShowCover = newClassName === 'open';
    if(wasOpen && newClassName === ''){
      this.menuBarClose.emit();
    }
    if(newClassName === 'open'){
      if (this.commonService.isPasswordLogin()) {
        this.multiValidUserAccount = false;
      } else {
        this.apiService.getCompanyList().subscribe(result=>{
          if(Array.isArray(result) && result.filter(item=>item.state === 1).length > 1){
            this.multiValidUserAccount = true
          }else{
            this.multiValidUserAccount = false
          }
        })
      }
    }
	}
	handleSwitch(){
    sessionStorage.removeItem('userSession');
		this.showScreenClassName = '';
		let link = ['course-select']
		this.router.navigate(link);
	}

	openLogoutDialog(){
    this.showScreenClassName = '';
    this.isShowCover = false;
    localStorage.removeItem('userName');
    this.logout.emit();
	}

	closeSmallDialog(){
		this.dialogOpacity = 0;
		setTimeout(()=>{
			this.dialogDisplay = 'none';
		},0)
	}

	handleBtnClick(type){
		this.closeSmallDialog();
		if(type === 'left'){
			this.showOrCloseFullPage();
			this.apiService.logout().subscribe(res => {
				if(res){
          console.log(res,'登出接口')
					//清除多公司记录
					this.commonService.clearLoginCredentials();
          this.commonService.clearMentorEnteredLocal();
          this.storeService.notification.mentorEntered.next(null);
          localStorage.removeItem('userId');
          localStorage.removeItem('transtalen-token');
          localStorage.removeItem('transtalenuserid');
					this.router.navigate(['new-login'])
				}
			})
		}
	}

	getUserInfoAPI():Promise<any>{
    return this.apiService.getUserInfo().toPromise();
	}

  getUserCampAPI():Promise<any>{
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/camp/list'
    }).toPromise();
  }

  goGDPR(){
    this.showScreenClassName = '';
    this.isShowCover = false;
    this.showGDPR.emit();
  }

  goExerciseBook():void{
    this.commonService.learningPortEventLogByCandy({'userId':localStorage.getItem('userId'),'learningPathMetaId':'','module':'作业','btnName':'点击作业薄','courseUnit':'','type':0}).then();
    this.router.navigate(['exercise-book']);
  }

  goTools():void{
    this.showScreenClassName = '';
    this.isShowCover = false;
    this.router.navigate(['app-tools']).then();
  }

  goAiCoach():void{
    this.showScreenClassName = '';
    this.isShowCover = false;
    this.router.navigate(['app-ai-coach']).then();
  }

  goLearningCenter(): void {
    this.showScreenClassName = '';
    this.isShowCover = false;
    if (this.router.url.indexOf('learning-map') === -1) {
      this.router.navigate(['learning-map']);
    }
  }

  goLeaderCoach(): void {
    if (!this.commonService.canEnterLeaderCoach(this.userAuthority)) {
      return;
    }
    this.showScreenClassName = '';
    this.isShowCover = false;
    const url = this.commonService.appendTokenToUrl(this.commonService.getLeaderCoachUrl(this.userAuthority));
    // 必须先落「已进导师」标记再跳外链，否则手机返回后 setOnceIno 常被取消，红点仍在
    this.markMentorEntered().then(() => {
      window.location.href = url;
    });
  }

  markMentorEntered(): Promise<void> {
    if (this.commonService.isMentorGuideDebugMode()) {
      return Promise.resolve();
    }
    if (this.mentorEnteredLocal && this.commonService.hasMentorEnteredLocal()) {
      return Promise.resolve();
    }
    this.mentorEnteredLocal = true;
    this.commonService.markMentorEnteredLocal();
    this.storeService.notification.mentorEntered.next(true);
    this.mentorEntered.emit();
    return this.commonService.setOnceIno(this.commonService.MENTOR_ENTERED_ONCE_VALUE)
      .toPromise()
      .then(() => undefined)
      .catch(() => undefined);
  }

  goToTerms(){
    window.open('https://terms.transtalent.cn/')
  }

  goPrivacy(){
	  window.open('https://oss.transtalent.cn/')
  }

  getUserHaveTools():Promise<any>{
    return this.apiService.ajax({
      'type': 'GET',
      'url':'/sr/tools/yyToolsLibrary/haveToolsAuthority'
    }).toPromise();
  }

  checkMentorEntered(): void {
    if (this.commonService.isMentorGuideDebugMode()) {
      this.mentorEnteredLocal = false;
      return;
    }
    if (this.commonService.hasMentorEnteredLocal()) {
      this.mentorEnteredLocal = true;
    }
    this.commonService.getOnceIno(this.commonService.MENTOR_ENTERED_ONCE_VALUE).then(result => {
      this.mentorEnteredLocal = result === 1 || this.commonService.hasMentorEnteredLocal();
      if (result === 1) {
        this.commonService.markMentorEnteredLocal();
      }
    });
  }

  /** 导师引导点击后同步 NEW：未进过导师时强制展示 */
  syncMentorBadgeAfterGuide(shouldShowNew: boolean): void {
    if (this.commonService.isMentorGuideDebugMode()) {
      this.mentorEnteredLocal = false;
      return;
    }
    if (shouldShowNew) {
      this.mentorEnteredLocal = false;
    }
  }

	ngOnInit() {
	  this.assetsRouteUrl = this.assetsRoute+'/picture/camp/headPortrait.png';
    this.checkMentorEntered();
    this.mentorRedDotSub = this.storeService.notification.mentorEntered.subscribe(value => {
      if (value === true) {
        this.mentorEnteredLocal = true;
      } else if (value === null) {
        // 账号切换重置：按当前账号重新校验，避免沿用上一账号的 true
        this.mentorEnteredLocal = false;
        this.checkMentorEntered();
      }
    });
		this.getUserInfoAPI().then(result=>{
      if('code' in result && !('id' in result)){
        return;
      }
      if(result){
        this.avatarUrl = result.headimgurl;
        this.userName = result.name;
        this.accountName = result.accountNumber || (result.phone.substr(0,3)+ "****" +result.phone.substr(7,4))
        this.isChannel = result.isChannel === 1;
        this.storeService.notification.isChannel.next(this.isChannel)
      }
    }).then(()=>{
      return this.getUserHaveTools().then(result=>{
        return this.isHaveTools = result;
      })
    }).then(()=>{
      return this.getUserCampAPI().then(result=>{
        return this.userCamp = result;
      })
    })
	}

	ngOnDestroy(){
    if (this.mentorRedDotSub) {
      this.mentorRedDotSub.unsubscribe();
    }
	}
}



// WEBPACK FOOTER //
// ./src/component-ui/menu-bar/component.ts